import type { Shadows } from '@mui/material';

export const generateShadows = (
  shadows: Shadows,
  includedShadowIndexes: number[],
) =>
  shadows.map((shadow, index) =>
    includedShadowIndexes.includes(index) ? shadow : 'none',
  ) as Shadows;
